import { ForgotPasswordForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

export function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
